import gql from 'graphql-tag'

import { seoFragment } from '../fragments/seo.js'
import { responsiveImageFragment } from '../fragments/images.js'
import { gridFragment } from '../fragments/dato.js'

export const getACasaTua = gql`
  ${seoFragment}
  ${responsiveImageFragment}
  ${gridFragment}
  query GetACasaTua($locale: SiteLocale) {
    aCasaTua(locale: $locale) {
      seo {
        ...SeoFragment
      }
      title
      introText
      menu {
        id
        subcategories {
          id
          title
          subtitle
          products {
            id
            name
            price
          }
        }
      }
      body {
        __typename
        ... on IntroBlockRecord {
          id
          introImage {
            id
            url
            width
            height
          }
          introText
          linkLabel
          linkUrl
          videoBackgroundUrl
          videoFullscreenUrl
        }
        ... on GridSectionRecord {
          ...GridFragment
        }
        ... on FullscreenImageRecord {
          id
          smallHeight
          image {
            id
            url
            landscape: responsiveImage(
              imgixParams: { fit: crop, w: 1920, h: 1080, ar: "16/9", fm: webp }
            ) {
              ...ResponsiveImageFragment
            }
            portrait: responsiveImage(
              imgixParams: { fit: crop, w: 1536, h: 2048, ar: "9/16", fm: webp }
            ) {
              ...ResponsiveImageFragment
            }
          }
        }
        ... on MaskTextRecord {
          id
          text
          overlapText
          isDark
        }
        ... on ZoomMasonryRecord {
          id
          images {
            scale
            id
            image {
              id
              responsiveImage(
                imgixParams: { auto: format, q: "60", fit: crop }
              ) {
                ...ResponsiveImageFragment
              }
            }
          }
        }
        ... on ListingMenuListRecord {
          id
          backgroundColor {
            hex
          }
          textColor {
            hex
          }
          pretitle
          list {
            id
            title
            link
            coverImage {
              id
              responsiveImage(
                imgixParams: { auto: format, q: "60", fit: crop }
              ) {
                ...ResponsiveImageFragment
              }
            }
          }
        }
        ... on LinkPanelListRecord {
          id
          panels {
            id
            title
            description
            image {
              id
              responsiveImage(
                imgixParams: { auto: format, q: "60", fit: crop }
              ) {
                ...ResponsiveImageFragment
              }
            }
            linkLabel
            linkUrl
          }
        }
        ... on ContactsBlockSlotRecord {
          id
          slot {
            id
            pretitle
            title
            items {
              id
              title
              linkUrl
              linkLabel
              ctaTheme
            }
          }
        }
        ... on CardCarouselRecord {
          id
          verticalRatio
          slides {
            id
            linkVideo
            linkVideoPreview
            image {
              id
              responsiveImage(
                imgixParams: { ar: "16:9", fit: crop, w: "2000", fm: webp }
              ) {
                ...ResponsiveImageFragment
              }
            }
            portrait: image {
              id
              responsiveImage(
                imgixParams: { ar: "4:5", fit: crop, w: "2000", fm: webp }
              ) {
                ...ResponsiveImageFragment
              }
            }
          }
        }
        ... on InfoBannerSlotRecord {
          id
          banner {
            id
            title
            description
            linkUrl
            backgroundColor {
              hex
            }
            textColor {
              hex
            }
            image {
              id
              responsiveImage(
                imgixParams: { auto: format, q: "60", fit: crop }
              ) {
                ...ResponsiveImageFragment
              }
            }
            imageMobile {
              id
              responsiveImage(
                imgixParams: { auto: format, q: "60", fit: crop }
              ) {
                ...ResponsiveImageFragment
              }
            }
            videoUrl
          }
        }
      }
    }
    home(locale: $locale) {
      hero {
        id
        cards {
          name
          slug
          startDate
          mainImage {
            responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
              ...ResponsiveImageFragment
            }
          }
        }
      }
    }
  }
`

export const getPiattiEVini = gql`
  ${seoFragment}
  ${responsiveImageFragment}
  ${gridFragment}
  query GetPiattiEVini($locale: SiteLocale) {
    allMenuCategories(locale: $locale) {
      id
      idGestionale
      menuCustomCode
      title: name
      link: slug
      coverImage: listingImage {
        id
        responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
          ...ResponsiveImageFragment
        }
      }
    }
    piattiEVini(locale: $locale) {
      seo {
        ...SeoFragment
      }
      title
      introText
      menuListPretitle
      body {
        __typename
        ... on IntroBlockRecord {
          id
          introImage {
            id
            url
            width
            height
          }
          introText
          linkLabel
          linkUrl
          videoBackgroundUrl
          videoFullscreenUrl
        }
        ... on GridSectionRecord {
          ...GridFragment
        }
        ... on FullscreenImageRecord {
          id
          smallHeight
          image {
            id
            url
            landscape: responsiveImage(
              imgixParams: { fit: crop, w: 1920, h: 1080, ar: "16/9", fm: webp }
            ) {
              ...ResponsiveImageFragment
            }
            portrait: responsiveImage(
              imgixParams: { fit: crop, w: 1536, h: 2048, ar: "9/16", fm: webp }
            ) {
              ...ResponsiveImageFragment
            }
          }
        }
        ... on MaskTextRecord {
          id
          text
          overlapText
          isDark
        }
        ... on ZoomMasonryRecord {
          id
          images {
            scale
            id
            image {
              id
              responsiveImage(
                imgixParams: { auto: format, q: "60", fit: crop }
              ) {
                ...ResponsiveImageFragment
              }
            }
          }
        }
        ... on ListingMenuListRecord {
          id
          backgroundColor {
            hex
          }
          textColor {
            hex
          }
          pretitle
          list {
            id
            title
            link
            coverImage {
              id
              responsiveImage(
                imgixParams: { auto: format, q: "60", fit: crop }
              ) {
                ...ResponsiveImageFragment
              }
            }
          }
        }
        ... on LinkPanelListRecord {
          id
          panels {
            id
            title
            description
            image {
              id
              responsiveImage(
                imgixParams: { auto: format, q: "60", fit: crop }
              ) {
                ...ResponsiveImageFragment
              }
            }
            linkLabel
            linkUrl
          }
        }
        ... on ContactsBlockSlotRecord {
          id
          slot {
            id
            pretitle
            title
            items {
              id
              title
              linkUrl
              linkLabel
              ctaTheme
            }
          }
        }
        ... on CardCarouselRecord {
          id
          verticalRatio
          slides {
            id
            linkVideo
            linkVideoPreview
            image {
              id
              responsiveImage(
                imgixParams: { ar: "16:9", fit: crop, w: "2000", fm: webp }
              ) {
                ...ResponsiveImageFragment
              }
            }
            portrait: image {
              id
              responsiveImage(
                imgixParams: { ar: "4:5", fit: crop, w: "2000", fm: webp }
              ) {
                ...ResponsiveImageFragment
              }
            }
          }
        }
        ... on InfoBannerSlotRecord {
          id
          banner {
            id
            title
            description
            linkUrl
            linkLabel
            linkSecondaryUrl
            linkSecondaryLabel
            backgroundColor {
              hex
            }
            textColor {
              hex
            }
            image {
              id
              responsiveImage(
                imgixParams: { auto: format, q: "60", fit: crop }
              ) {
                ...ResponsiveImageFragment
              }
            }
            imageMobile {
              id
              responsiveImage(
                imgixParams: { auto: format, q: "60", fit: crop }
              ) {
                ...ResponsiveImageFragment
              }
            }
            videoUrl
          }
        }
      }
    }
    home(locale: $locale) {
      hero {
        id
        cards {
          name
          slug
          startDate
          mainImage {
            responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
              ...ResponsiveImageFragment
            }
          }
        }
      }
    }
  }
`

export const getMenuCategory = gql`
  ${seoFragment}
  ${responsiveImageFragment}
  ${gridFragment}
  query GetMenuCategory($locale: SiteLocale, $category: String) {
    allMenuCategories(locale: $locale) {
      id
      idGestionale
      menuCustomCode
      name
      slug
    }
    menuCategory(locale: $locale, filter: { slug: { eq: $category } }) {
      seo {
        ...SeoFragment
      }
      id
      idGestionale
      menuCustomCode
      name
      slug
      _allSlugLocales {
        value
        locale
      }
      title
      subtitle
      intro
      hideSubCategoriesSidebar
      excludedIds
      body {
        __typename
        ... on IntroBlockRecord {
          id
          introImage {
            id
            url
            width
            height
          }
          introText
          linkLabel
          linkUrl
          videoBackgroundUrl
          videoFullscreenUrl
        }
        ... on GridSectionRecord {
          ...GridFragment
        }
        ... on FullscreenImageRecord {
          id
          smallHeight
          image {
            id
            url
            landscape: responsiveImage(
              imgixParams: { fit: crop, w: 1920, h: 1080, ar: "16/9", fm: webp }
            ) {
              ...ResponsiveImageFragment
            }
            portrait: responsiveImage(
              imgixParams: { fit: crop, w: 1536, h: 2048, ar: "9/16", fm: webp }
            ) {
              ...ResponsiveImageFragment
            }
          }
        }
        ... on MaskTextRecord {
          id
          text
          overlapText
          isDark
        }
        ... on ZoomMasonryRecord {
          id
          images {
            scale
            id
            image {
              id
              responsiveImage(
                imgixParams: { auto: format, q: "60", fit: crop }
              ) {
                ...ResponsiveImageFragment
              }
            }
          }
        }
        ... on ListingMenuListRecord {
          id
          backgroundColor {
            hex
          }
          textColor {
            hex
          }
          pretitle
          list {
            id
            title
            link
            coverImage {
              id
              responsiveImage(
                imgixParams: { auto: format, q: "60", fit: crop }
              ) {
                ...ResponsiveImageFragment
              }
            }
          }
        }
        ... on LinkPanelListRecord {
          id
          panels {
            id
            title
            description
            image {
              id
              responsiveImage(
                imgixParams: { auto: format, q: "60", fit: crop }
              ) {
                ...ResponsiveImageFragment
              }
            }
            linkLabel
            linkUrl
          }
        }
        ... on ContactsBlockSlotRecord {
          id
          slot {
            id
            pretitle
            title
            items {
              id
              title
              linkUrl
              linkLabel
              ctaTheme
            }
          }
        }
        ... on CardCarouselRecord {
          id
          verticalRatio
          slides {
            id
            linkVideo
            linkVideoPreview
            image {
              id
              responsiveImage(
                imgixParams: { ar: "16:9", fit: crop, w: "2000", fm: webp }
              ) {
                ...ResponsiveImageFragment
              }
            }
            portrait: image {
              id
              responsiveImage(
                imgixParams: { ar: "4:5", fit: crop, w: "2000", fm: webp }
              ) {
                ...ResponsiveImageFragment
              }
            }
          }
        }
        ... on InfoBannerSlotRecord {
          id
          banner {
            id
            title
            description
            linkUrl
            backgroundColor {
              hex
            }
            textColor {
              hex
            }
            image {
              id
              responsiveImage(
                imgixParams: { auto: format, q: "60", fit: crop }
              ) {
                ...ResponsiveImageFragment
              }
            }
            imageMobile {
              id
              responsiveImage(
                imgixParams: { auto: format, q: "60", fit: crop }
              ) {
                ...ResponsiveImageFragment
              }
            }
            videoUrl
          }
        }
      }
    }
    home(locale: $locale) {
      hero {
        id
        cards {
          name
          slug
          startDate
          mainImage {
            responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
              ...ResponsiveImageFragment
            }
          }
        }
      }
    }
  }
`
